import { ButtonComponentConfig, ButtonSize, IconType } from '@rappider/rappider-components/utils';

export const ExpandAllButtonConfig: ButtonComponentConfig = {
  icon: {
    name: 'fas fa-plus',
    type: IconType.FontAwesome,
  }
};
